//fetch ip info begin
export const FETCH_IP_INFO_BEGIN = "FETCH_IP_INFO_BEGIN";

//fetch ip info success
export const FETCH_IP_INFO_SUCCESS = "FETCH_IP_INFO_SUCCESS";

//fetch ip info failure
export const FETCH_IP_INFO_FAILURE = "FETCH_IP_INFO_FAILURE";
